module.exports = __webpack_public_path__ + "img/Khadya.37070cf5.png";